import { createPortal } from 'react-dom';
import { ComponentProps, FC, PropsWithChildren } from 'react';
import { cn } from '@/lib/utils.ts';
import { useConfirmationDialogContext } from '@/components/ui/ConfirmDialog.Context.tsx';

type ModalProps = PropsWithChildren<{
  onClose: () => void;
  isDirty?: boolean;
  closeOnOverlayClick?: boolean;
}> &
  ComponentProps<'div'>;

const Modal: FC<ModalProps> = ({
  onClose,
  isDirty,
  closeOnOverlayClick = false,
  ...props
}) => {
  const { showDialog } = useConfirmationDialogContext();

  const handleOverlayClick = async () => {
    if (!closeOnOverlayClick) return;
    if (isDirty) {
      const confirmed = await showDialog({
        title: 'Niezapisane zmiany',
        description:
          'Masz niezapisane zmiany. Czy na pewno chcesz zamknąć okno? Wprowadzone dane zostaną utracone.',
        variant: 'destructive',
        confirmText: 'Odrzuć zmiany',
      });
      if (!confirmed) return;
    }
    onClose();
  };

  return createPortal(
    <div
      onClick={handleOverlayClick}
      className="fixed inset-0 z-50 flex items-center justify-center bg-overlay px-4 backdrop-blur-[2px]"
    >
      {/* Okno stoi na gołym `createPortal`, więc rolę trzeba nadać ręcznie —
          bez niej czytnik ekranu nie wie, że to okno dialogowe. */}
      <div
        role="dialog"
        aria-modal
        {...props}
        onClick={(e) => e.stopPropagation()}
        className={cn(
          'relative max-h-[90dvh] w-full max-w-[600px] overflow-y-auto overscroll-contain rounded-xl bg-basic-white',
          props.className,
        )}
      />
    </div>,
    document.body,
  );
};

export default Modal;
